import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSync } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Checkbox from './checkbox';

const ListHeader = ({ checkboxDisabled, isChecked, onCheckboxChange,
  hideDeleteButton, disableDeleteButton, onDelete,
  hideAddButton, disableAddButton, addButtonLink, onAdd,
  extraButtons = [],
  saving, data,
}) => (
  <div className="d-flex justify-content-between mb-2 flex-column">
    <div className="d-flex justify-content-between align-items-center">
      <div data-testid="list-header-checkbox">
        <Checkbox size="large" disabled={checkboxDisabled} isChecked={isChecked} onChange={onCheckboxChange} />
      </div>
      <div className="d-flex align-items-center" data-testid="list-header-actions">
        {extraButtons}
        <button hidden={hideDeleteButton} type="button" className="mr-1 btn btn-secondary btn-primary-shadow pb-2 pt-2 rounded-lg" disabled={disableDeleteButton} onClick={onDelete} data-testid="delete-button">
          <div>
            {data.t.read("delete")}
            {saving && <FontAwesomeIcon className="ml-2 text-secondary infinite-rotate faded" icon={faSync} data-testid="sync-icon" />}
          </div>
        </button>
      </div>
    </div>
    <div className="my-3">
      { addButtonLink
        ? <Link hidden={hideAddButton} to={addButtonLink} className="w-100 btn btn-primary btn-primary-shadow p-2 py-3 d-flex align-items-center justify-content-center" data-testid="add-link">
            <FontAwesomeIcon className="mr-2" icon={faPlus} data-testid="add-icon" />
            {data.t.read("add_new")}
          </Link>
        : <button hidden={hideAddButton} type="button" className="w-100 btn btn-primary btn-primary-shadow pb-2 py-3 d-flex align-items-center justify-content-center" disabled={disableAddButton} onClick={onAdd} data-testid="add-button">
            <div className="action-buttons action-buttons-sm">
              <FontAwesomeIcon className="mr-2" icon={faPlus} data-testid="add-icon" />
              {data.t.read("add_new")}
              {saving && <FontAwesomeIcon className="ml-2 text-secondary infinite-rotate faded" icon={faSync} data-testid="sync-icon" />}
            </div>
          </button>
      }
    </div>
  </div>
);

export default ListHeader;
